import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Panel, { PanelTitle, PanelSpacer } from 'components/layout/Panel'
import { Container } from 'roadie-ui'
import { FeatureFlag } from 'Optimizely'
import { fetchDriverScorecardSummary } from 'actions/scorecard'
import {
  COMMITMENT_RATE_METRIC_NAME,
  ON_TIME_RATE_METRIC_NAME,
  getScorecardByMetricName,
  getStatColor,
} from 'util/scorecard'
import { MyStatsPanel } from './MyStatsPanel'
import { useLocalization, LocalizedText } from 'localization'

const ScorecardFetcher: React.FC<{ enabled: boolean; profileId: number }> = ({ enabled, profileId }) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (enabled) {
      fetchDriverScorecardSummary(profileId)(dispatch)
    }
  }, [enabled, profileId, dispatch])

  return null
}

export const MyStatsSection: React.FC = () => {
  const { t } = useLocalization()
  const profileId = useSelector((state: any) => state.profile.id)
  const scorecardSummary = useSelector((state: any) => state.scorecardSummary)
  const commitmentRateScorecard = getScorecardByMetricName(scorecardSummary, COMMITMENT_RATE_METRIC_NAME)
  const onTimeRateScorecard = getScorecardByMetricName(scorecardSummary, ON_TIME_RATE_METRIC_NAME)

  return (
    <FeatureFlag feature="driver_scorecard">
      {(driverScorecardEnabled) => (
        <FeatureFlag feature="on_time_rate_scorecard">
          {(onTimeRateEnabled) => {
            const commitmentRateVisible = driverScorecardEnabled && commitmentRateScorecard != null
            const onTimeRateVisible = onTimeRateEnabled && onTimeRateScorecard != null
            return (
              <>
                <ScorecardFetcher enabled={driverScorecardEnabled || onTimeRateEnabled} profileId={profileId} />
                {(commitmentRateVisible || onTimeRateVisible) && (
                  <>
                    <PanelTitle>
                      <LocalizedText translationKey="dweb_dashboard_my_stats_section_my_stats" />
                    </PanelTitle>
                    <Panel noPadding>
                      <Container.Grid>
                        {onTimeRateVisible && (
                          <MyStatsPanel
                            label={t('dweb_common_on_time_rate')}
                            rate={onTimeRateScorecard.score}
                            to="/on-time-rate"
                            getStatColor={(rate, isDarkMode) => getStatColor(rate, isDarkMode, 90, 85)}
                            isLast={!commitmentRateVisible}
                          />
                        )}
                        {commitmentRateVisible && (
                          <MyStatsPanel
                            label={t('dweb_common_commitment_rate')}
                            rate={commitmentRateScorecard.score}
                            to="/commitment-rate"
                            getStatColor={(rate, isDarkMode) => getStatColor(rate, isDarkMode, 95, 90)}
                            isLast
                          />
                        )}
                      </Container.Grid>
                    </Panel>
                    <PanelSpacer />
                  </>
                )}
              </>
            )
          }}
        </FeatureFlag>
      )}
    </FeatureFlag>
  )
}
